import { queryOptions } from '@w/react-query/db'
import { s } from '@w/schema'
import type { SpaceResource } from '../router/spaces-resources'

/** The page a space's databases belong to: the caller's personal root in a private space; a shared space's root page. */
export function databaseRootId(resource: SpaceResource) {
  return resource.space.kind === 'private' ? resource.space.personalRootId : resource.space.id
}

/** The space's database root, read to prove it still exists. */
export function databaseSpaceRootOptions(resource: SpaceResource) {
  const id = databaseRootId(resource)
  return { queryKey: ['database-space-root', resource.space.id, id], queryFn: async () => {
    const [root] = await resource.customDb.query<{ id: string }>('SELECT id FROM pages WHERE id=? AND deletedAt IS NULL', [id])
    if (!root) throw new Error('Space unavailable')
    return root.id
  } }
}

// Module scope (Zod: define schemas once): inline schemas paid construction on every call.
const ddlIdSchema = s.object({ id: s.string() })

/** The space's custom databases, refetched on every schema change (DDL log row). */
export function databasesOptions(resource: SpaceResource) {
  const changes = queryOptions(resource.db.query`SELECT ${resource.db.__cdb_ddl_log.id} FROM ${resource.db.__cdb_ddl_log}`, ddlIdSchema)
  return { queryKey: ['databases', resource.space.id], queryFn: () => resource.customDb.listDatabases(), subscribe: changes.subscribe }
}
